/* eslint-disable no-self-assign */
import courseTemplate from '@/api/courseTemplate'
import get from 'lodash/get'

const INITIAL_STATE = {
  courseTemplateLabels: [],
  courseTemplateList: {},
}

export default {
  namespace: 'courseTemplate',

  state: INITIAL_STATE,

  reducers: {
    init() {
      return { ...INITIAL_STATE }
    },
    setCourseTemplateLabels(state, { payload }) {
      return { ...state, courseTemplateLabels: payload }
    },
    setCourseTemplateList(state, { payload }) {
      return { ...state, courseTemplateList: payload }
    },
  },

  effects: {
    *getCourseTemplateLabels(
      { payload, skipPut, successCallback, errorCallback },
      { call, put, select },
    ) {
      const { account } = yield select(state => state.auth)
      const response = yield call(courseTemplate.getCourseTemplateLabels, {
        params: { accountId: get(account, 'accountId'), ...payload },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        if (!skipPut) {
          yield put({ type: 'courseTemplate/setCourseTemplateLabels', payload: resData })
        }

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *deleteCourseTemplateLabel({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(courseTemplate.deleteCourseTemplateLabel, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *deleteCourseTemplateFromLabel({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(courseTemplate.deleteCourseTemplateFromLabel, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }
      if (error) {
        errorCallback?.(error)
      }
    },

    *getCourseTemplates({ payload, successCallback, errorCallback }, { call, put, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(courseTemplate.getCourseTemplates, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        yield put({ type: 'courseTemplate/setCourseTemplateList', payload: resData })
        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getCourseTemplatesAddable({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(courseTemplate.getCourseTemplatesAddable, {
        params: { ...payload, accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getCourseTemplateById({ payload, successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(courseTemplate.getCourseTemplateById, {
        ...payload,
        params: { accountId: get(account, 'accountId') },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false
        successCallback?.(resData?.data || [])
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *getCourseTemplateUpUrl({ successCallback, errorCallback }, { call, select }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(courseTemplate.getCourseTemplateUpUrl, {
        // accountId: get(account, 'accountId'),
        params: { accountId: get(account, 'accountId'), useOctetStream: false },
      })
      const { status, data: resData } = response
      let hasError = true

      if (status === 200) {
        hasError = false

        successCallback?.(resData.data)
      }
      if (hasError) {
        errorCallback?.()
      }
    },

    *createCourseTemplateLabel({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(courseTemplate.createCourseTemplateLabel, {
        data: {
          ...payload,
        },
        params: { accountId: get(account, 'accountId'), ...payload },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message, data } = resData
        if (success) {
          error = undefined
          successCallback?.(data)
        } else {
          error = message
        }
      }

      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *editCourseTemplate({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(courseTemplate.editCourseTemplate, {
        data: payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData = {} } = response

      let error = ''

      const { success, message } = resData

      if (status === 200) {
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      } else {
        error = message
      }

      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *editCourseTemplateLabel({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const { labelId, ...params } = payload
      const response = yield call(courseTemplate.editCourseTemplateLabel, {
        labelId,
        params: { accountId: get(account, 'accountId'), ...params },
      })

      const { status, data: resData = {} } = response

      let error = ''

      const { success, message } = resData

      if (status === 200) {
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      } else {
        error = message
      }

      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *editCourseTemplateLabelsById(
      { payload, successCallback, errorCallback },
      { call, select, put },
    ) {
      const { account } = yield select(state => state.auth)
      const { courseTempId, data } = payload
      const response = yield call(courseTemplate.editCourseTemplateLabelsById, {
        courseTempId,
        data,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData = {} } = response

      let error = ''

      const { success, message } = resData

      if (status === 200) {
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      } else {
        error = message
      }

      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *editCourseTemplateLabelVideosById(
      { payload, successCallback, errorCallback },
      { call, select, put },
    ) {
      const { account } = yield select(state => state.auth)
      const { labelId, data } = payload
      const response = yield call(courseTemplate.editCourseTemplateLabelVideosById, {
        labelId,
        data,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData = {} } = response

      let error = ''

      const { success, message } = resData

      if (status === 200) {
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      } else {
        error = message
      }

      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *createCourseTemplate({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)
      const response = yield call(courseTemplate.createCourseTemplate, {
        data: {
          ...payload,
        },
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }

      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },

    *addCourseTemplateProgram({ payload, successCallback, errorCallback }, { call, select, put }) {
      const { account } = yield select(state => state.auth)

      const response = yield call(courseTemplate.addCourseTemplateProgram, {
        courseTempId: payload.tempId,
        data: payload,
        params: { accountId: get(account, 'accountId') },
      })

      const { status, data: resData } = response

      let error = ''

      if (status === 200) {
        const { success, message } = resData
        if (success) {
          error = undefined
          successCallback?.()
        } else {
          error = message
        }
      }

      if (error) {
        yield put({ type: 'app/notify', payload: { message: error, severity: 'error' } })
        errorCallback?.(error)
      }
    },
  },
}
